import { useNavigate } from "react-router-dom"

export const GuestHome = () => {
    const navigate = useNavigate();
    return (
        <>


            <div className="flex items-center justify-center min-h-screen z-999">
                <div className="absolute left-4 top-2 h-full w-40">
                    <img src="https://digiit.biz/assets/digiit-logo-dark.png" />
                </div>
                
                <div className="w-full text-center">
                    <h2 className="max-w-screen mb-24 font-sans text-3xl font-bold leading-none tracking-tight text-[#241B00] sm:text-4xl md:mx-auto">
                        "Manage Digital Fusion Network"
                    </h2>
                    <div className="relative px-4 sm:px-0">
                        <div className="absolute inset-0 bg-[#FFC000]  h-1/2" />
                        <div className="relative grid mx-auto overflow-hidden  sm:max-w-screen-sm sm:grid-cols-4 lg:max-w-screen-xl grid-cols-4 gap-4">
                            <div className="inline-block mx-4 p-8 text-center bg-[#241B00] cursor-pointer hover:border border-[#FFE491]" onClick={()=>{window.open('/web-platform', '_blank', 'noopener,noreferrer')}}>
                                <div className="flex items-center justify-center w-12 h-12 mx-auto mb-4 rounded-full bg-[#241B00]">
                                    <svg
                                        width="100%"
                                        height="100%"
                                        viewBox="0 0 200 200"
                                        xmlns="http://www.w3.org/2000/svg"
                                        transform="scale(2)" /* Scale the SVG content to double size */
                                    >
                                        <path
                                            d="M60 130c-15 0-27-12-27-27s12-27 27-27h5c3-9 12-15 22-15 10 0 19 6 22 15h5c15 0 27 12 27 27s-12 27-27 27H60z"
                                            fill="#FFC000"
                                        />

                                        <text
                                            x="40"
                                            y="110"
                                            font-family="Arial, sans-serif"
                                            font-size="50"
                                            fill="#241B00"
                                            font-weight="bold"
                                        >
                                            s3
                                        </text>

                                        <circle cx="120" cy="120" r="30" stroke="#241B00" stroke-width="6" fill="none" />
                                        <line x1="120" y1="90" x2="120" y2="150" stroke="#241B00" stroke-width="6" />
                                        <line x1="90" y1="120" x2="150" y2="120" stroke="#241B00" stroke-width="6" />
                                        <line x1="103.9" y1="103.9" x2="136.1" y2="136.1" stroke="#241B00" stroke-width="6" />
                                        <line x1="103.9" y1="136.1" x2="136.1" y2="103.9" stroke="#241B00" stroke-width="6" />
                                        <circle cx="120" cy="120" r="10" fill="#FFC000" />


                                    </svg>
                                </div>
                                <p className="font-bold tracking-wide text-[#FFC000]">
                                    S3WEB
                                </p>
                                <p className="text-xs font-light text-[#FFC000]">
                                    Intelligent Content Management system
                                </p>
                            </div>


                            <div className="inline-block  mx-4 p-8 text-center bg-[#241B00] cursor-pointer hover:border border-[#FFE491]" onClick={()=>{window.open('/csg-portal', '_blank', 'noopener,noreferrer')}}>
                                <div className="flex items-center justify-center w-12 h-12 mx-auto mb-4 rounded-full bg-[#241B00]">
                                    
                                    <svg
                                        width="200"
                                        height="200"
                                        viewBox="0 0 200 200"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <circle cx="100" cy="100" r="80" fill="none" stroke="#FFC000" stroke-width="10" />

                                        <path
                                            d="M140,60 A40,40 0 0,0 60,140"
                                            fill="none"
                                            stroke="#FFC000"
                                            stroke-width="10"
                                        />

                                        <path
                                            d="M60,60 A40,40 0 0,0 140,140"
                                            fill="none"
                                            stroke="#FFC000"
                                            stroke-width="10"
                                        />
                                        <circle cx="100" cy="100" r="20" fill="#FFC000" />

                                    </svg>


                                </div>
                                <p className="font-bold tracking-wide text-[#FFC000]">
                                    CSG
                                </p>
                                <p className="text-xs font-light text-[#FFC000]">
                                 Success and Operation Management
                                </p>
                            </div>
                            <div className="inline-block  mx-4 p-8 text-center bg-[#241B00] cursor-pointer hover:border border-[#FFE491]" onClick={()=>{window.open('/nexus', '_blank', 'noopener,noreferrer')}}>
                                <div className="flex items-center justify-center w-12 h-12 mx-auto mb-4 rounded-full bg-[#241B00]">
                                    
                                    <svg
                                        width="200"
                                        height="200"
                                        viewBox="0 0 200 200"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <rect width="200" height="200" fill="#241B00" />

                                        <path
                                            d="M50,50 L150,150"
                                            stroke="#FFC000" stroke-width="10" stroke-linecap="round"
                                        />

                                        <path
                                            d="M150,50 L50,150"
                                            stroke="#FFC000" stroke-width="10" stroke-linecap="round"
                                        />

                                        <circle cx="100" cy="100" r="20" fill="#FFC000" />

                                        
                                    </svg>

                                </div>
                                <p className="font-bold tracking-wide text-[#FFC000]">
                                    NEXUS
                                </p>
                                <p className="text-xs font-light text-[#FFC000]">
                                    Domain Naming Management System
                                </p>                                
                            </div>
                            <div className="inline-block  mx-4 p-8 text-center bg-[#241B00] cursor-pointer hover:border border-[#FFE491]" onClick={()=>{window.open('https://trax.digiit.io', '_blank', 'noopener,noreferrer')}}>
                                <div className="flex items-center justify-center w-12 h-12 mx-auto mb-4 rounded-full bg-[#241B00]">
                                    
                                    <svg
                                        width="200"
                                        height="200"
                                        viewBox="0 0 200 200"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <rect width="200" height="200" fill="#241B00" />

                                        <path
                                            d="M30,170 L170,30"
                                            stroke="#FFC000" stroke-width="12" stroke-linecap="round"
                                        />

                                        <path
                                            d="M30,30 L170,170"
                                            stroke="#FFC000" stroke-width="12" stroke-linecap="round"
                                        />

                                        <path
                                            d="M100,20 L100,180"
                                            stroke="#FFC000" stroke-width="12" stroke-linecap="round"
                                        />

                                        <path
                                            d="M20,100 L180,100"
                                            stroke="#FFC000" stroke-width="12" stroke-linecap="round"
                                        />

                                        <circle cx="100" cy="100" r="20" fill="#FFC000" />

                                    </svg>

                                </div>
                                <p className="font-bold tracking-wide text-[#FFC000]">
                                    TRAX
                                </p>
                                <p className="text-xs font-light text-[#FFC000]">
                                    Logs Management System
                                </p>                                 
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}